import { useState} from "react";
import {Outlet} from "react-router-dom";
/*import Turnstile, { useTurnstile } from "react-turnstile";*/
const ReportLayout=()=>{
   /* const turnstile = useTurnstile();*/
    /*const [token,setToken]=useState(null)*/
    const [token,setToken]=useState("")

    return <>

        {/*{token && <Outlet context={[token, setToken]}/>} */}
        <Outlet context={[token, setToken]}/>

    </>
}
export default ReportLayout;